import { DonationPaymentStatus, DonationType } from 'src/app/models/donation.interface';

export enum DonationsEntrySortKey {
    AMOUNT = 'amount',
    DATE = 'date',
    CHANNEL = 'channel.name',
    PROJECT = 'project.name',
    TAGS = 'donator.tags',
    HAS_DONATOR = 'donator',
    PAYMENT_STATUS = 'paymentStatus',
    RECEIPT = 'receipt',
    DONATOR_NAME = 'donatorName',
}

export interface FindDonationEntryDto {
    skip: number;

    limit: number;

    sortKey: DonationsEntrySortKey;

    sortType: 'asc' | 'desc';

    donatorSearch?: string;

    citySearch?: string;

    mailSearch?: string;

    minAmount?: number;

    maxAmount?: number;

    startDate?: string;

    endDate?: string;

    channel?: string;

    projects?: string[];

    tags?: string[];

    type?: DonationType;

    hasDonator?: boolean;

    permanentDonation?: boolean;

    paid?: boolean;

    hasReceipt?: boolean;

    checkAnonymous?: boolean;

    unknownAddress?: boolean;

    hasMail?: string;

    purposeName?: string;
}
